import "core-js/modules/web.dom-collections.iterator.js";
let _ = (t)=>t, t, t1;
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { Element } from '@klarna/ui';
import { Fragment, useEffect, useRef, useState } from 'react';
const REVEAL_MS = 250;
const wrapperStyles = (expanded)=>css(t || (t = _`
  display: grid;
  grid-template-rows: ${0};
  opacity: ${0};
  transition:
    grid-template-rows ${0}ms ease,
    opacity ${0}ms ease;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`), expanded ? '1fr' : '0fr', expanded ? 1 : 0, REVEAL_MS, REVEAL_MS);
const innerStyles = css(t1 || (t1 = _`
  overflow: hidden;
  min-height: 0;
`));
/**
 * Smoothly reveals its `children` (typically a `<Disclaimer>`) by animating
 * the container's height from `0` to `auto` when content first becomes
 * available. Prevents a layout jump when the disclaimer is resolved via an
 * asynchronous request (e.g. the marketing-disclosures BFF) after the modal
 * has already opened.
 */ const RevealDisclaimer = ({ hasContent, animate = false, children })=>{
    const startsExpandedRef = useRef(hasContent);
    const [isExpanded, setIsExpanded] = useState(startsExpandedRef.current);
    useEffect(()=>{
        if (!hasContent || isExpanded) return;
        const raf = requestAnimationFrame(()=>setIsExpanded(true));
        return ()=>cancelAnimationFrame(raf);
    }, [
        hasContent,
        isExpanded
    ]);
    if (!animate) return /*#__PURE__*/ _jsx(Fragment, {
        children: children
    });
    if (!hasContent) return null;
    return /*#__PURE__*/ _jsx(Element, {
        webOnlyProps: {
            css: wrapperStyles(isExpanded)
        },
        children: /*#__PURE__*/ _jsx(Element, {
            webOnlyProps: {
                css: innerStyles
            },
            children: children
        })
    });
};
export default RevealDisclaimer;
